/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Cta_Title_1Inputs */

const en_services_cta_title_1 = /** @type {(inputs: Services_Cta_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with the problem.`)
};

const lv_services_cta_title_1 = /** @type {(inputs: Services_Cta_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sāciet ar problēmu.`)
};

/**
* | output |
* | --- |
* | "Start with the problem." |
*
* @param {Services_Cta_Title_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_cta_title_1 = /** @type {((inputs?: Services_Cta_Title_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Cta_Title_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_cta_title_1(inputs)
	return en_services_cta_title_1(inputs)
});